import React, { useState } from "react";
import { requestMagicLink } from "../api";

// Passwordless sign-in form, shared by the Notifications page and the quick
// account modal so the two never drift apart.
function SignInForm({ blurb }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    setError("");
    try {
      await requestMagicLink(email.trim());
      setSent(true);
    } catch {
      setError("Couldn't send the sign-in link. Try again in a moment.");
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="alert alert-success" role="status">
        <strong>Check your email for a sign-in link.</strong>
        <div className="small mt-1">
          The link expires in 15 minutes. If it doesn't arrive, check your spam folder.
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      {blurb && <p className="text-muted small">{blurb}</p>}
      <label htmlFor="signin-email" className="form-label small mb-1">
        Email address
      </label>
      <input
        id="signin-email"
        type="email"
        required
        className="form-control mb-2"
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoComplete="email"
      />
      {error && (
        <div className="text-danger small mb-2" role="alert">
          {error}
        </div>
      )}
      <button type="submit" className="btn btn-primary w-100" disabled={sending}>
        {sending ? "Sending..." : "Send me a sign-in link"}
      </button>
      <p className="text-muted small mt-2 mb-0">
        No password needed. We email you a one-time link.
      </p>
    </form>
  );
}

export default SignInForm;
